const DEFAULT_START_NODE = {
  id: 'start',
  type: 'input',
  data: { name: 'Start' },
  category: 'Start',
  position: { x: 250, y: 50 },
};

export const resolveWorkflowJson = (builderRef, preJsonData) => {
  if (builderRef?.current) {
    const jsonData = builderRef.current.getWorkflowJsonData();
    if (!jsonData) return null;
    return jsonData;
  }

  if (preJsonData) {
    try {
      return typeof preJsonData === 'string'
        ? JSON.parse(preJsonData)
        : preJsonData;
    } catch {
      return null;
    }
  }

  return { nodes: [DEFAULT_START_NODE], edges: [] };
};

export const buildPublishPayload = (workflowJson, values, publishedAtValue) => {
  const workflowImageId =
    values.workflowImage && values.workflowImage.length > 0
      ? values.workflowImage[0].id || values.workflowImage[0].file_id
      : null;

  const { workflowImage, ...dataWithoutImage } = values;
  const paymentEnabled = Boolean(values.payment_enabled);
  const paymentProviderId =
    paymentEnabled && values.payment_provider_id
      ? Number(values.payment_provider_id)
      : null;
  const paymentCurrency =
    paymentEnabled && values.payment_currency
      ? String(values.payment_currency).trim().toUpperCase()
      : null;

  const rawLinkableWorkflows = values.linkable_workflow_ids || [];
  const linkableWorkflowIds = rawLinkableWorkflows.map((item) =>
    typeof item === 'object' ? item.value : item
  );
  const parentWorkflow =
    typeof values.parent_workflow_id === 'object'
      ? values.parent_workflow_id?.value
      : values.parent_workflow_id;

  const workflowLicenseMode =
    values.workflow_license_mode ||
    (values.license_renewal === 1 || values.license_renewal === true
      ? 'license_renewal'
      : 'new_license');

  return {
    ...dataWithoutImage,
    payment_enabled: paymentEnabled,
    payment_provider_id: Number.isNaN(paymentProviderId)
      ? null
      : paymentProviderId,
    payment_currency: paymentCurrency,
    stages_json: JSON.stringify(workflowJson),
    published: 1,
    publishedAt: publishedAtValue,
    workflow_image_id: workflowImageId,
    linked_studies_enabled: linkableWorkflowIds.length > 0,
    linkable_workflow_ids: linkableWorkflowIds,
    parent_workflow_id: parentWorkflow ? Number(parentWorkflow) : null,
    workflow_license_mode: workflowLicenseMode,
    license_renewal: workflowLicenseMode === 'license_renewal',
  };
};
